module.exports = __webpack_public_path__ + "static/media/OTPP.b79ee003.png";